<template>
    <div :class="prefixCls">
        <slot></slot>
    </div>
</template>
<script>
    const prefixCls = 'yy-btn-group'
    /**
     * @displayName ButtonGroup
     */
    export default {
        name: 'YYButtonGroup',
        data() {
            return {
                prefixCls: prefixCls
            }
        }
    }
</script>
